import React from 'react'

type MenuButtonProps = {
    isOpen: boolean;
    onToggle: () => void;
    icon: React.ReactNode;
    label: string;
    disabled?: boolean;
}

const MenuButton = ({
    isOpen,
    onToggle,
    icon,
    label,
    disabled = false }: MenuButtonProps) => {
    return (
        <button
            data-testid="category-relevancy-menu-btn"
            className={`tw-pr-4 tw-pl-2 tw-h-8 tw-text-ink ${isOpen ? 'tw-bg-surface-hover' : 'tw-bg-surface hover:tw-bg-surface-hover'
                } tw-rounded tw-inline-flex tw-justify-center tw-items-center tw-gap-1.5`}
            onClick={onToggle}
            disabled={disabled}
            aria-haspopup="true"
            aria-expanded={isOpen}
        >
            {icon}
            <div className="tw-text-sm tw-leading-tight">
                {label}
            </div>
        </button>)
}

export default MenuButton
